import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import IconButton from "@react/shared/ui/IconButton"
import { useDropdownMenu, MenuPanel, MENU_ITEM, MENU_ITEM_DANGER, MENU_SEPARATOR } from "@react/shared/ui/DropdownMenu"

const MENU_WIDTH = 220

const QuoteRowMenu = ({ quote, onValidation, onCreateProject, onDuplicate, onNewVersion, onSaveAsTemplate, onDelete }) => {
  const { open, close, toggle, pos, btnRef, menuRef } = useDropdownMenu({ width: MENU_WIDTH, align: "right" })

  const run = handler => e => {
    e.stopPropagation()
    close()
    handler?.(quote)
  }

  return (
    <>
      <IconButton
        ref       = {btnRef}
        size      = "md"
        title     = {I18n.t("quotes.builder.row_menu.actions")}
        onClick   = {toggle}
        className = {open ? "bg-slate-100 text-slate-900" : ""}
      >
        <FontAwesomeIcon icon="ellipsis-v" />
      </IconButton>

      {open && (
        <MenuPanel menuRef={menuRef} pos={pos} width={MENU_WIDTH}>
          {quote.project_url && (
            <a href={quote.project_url} className={MENU_ITEM} onClick={close}>
              <FontAwesomeIcon icon="hard-hat" />
              {I18n.t("quotes.bigcard.view_project")}
            </a>
          )}
          {quote.validation_url && onValidation && (
            <button type="button" className={MENU_ITEM} onClick={run(onValidation)}>
              <FontAwesomeIcon icon="user-check" />
              {I18n.t("validation.workflow.menu_item")}
            </button>
          )}
          {quote.can_convert_to_project && onCreateProject && (
            <button type="button" className={MENU_ITEM} onClick={run(onCreateProject)}>
              <FontAwesomeIcon icon="hard-hat" />
              {I18n.t("quotes.bigcard.convert_to_project")}
            </button>
          )}
          {quote.can_duplicate && onDuplicate && (
            <button type="button" className={MENU_ITEM} onClick={run(onDuplicate)}>
              <FontAwesomeIcon icon="copy" />
              {I18n.t("button.duplicate")}
            </button>
          )}
          {quote.can_duplicate && onNewVersion && (
            <button type="button" className={MENU_ITEM} onClick={run(onNewVersion)}>
              <FontAwesomeIcon icon="code-branch" />
              {I18n.t("quotes.bigcard.new_version")}
            </button>
          )}
          {quote.can_save_as_template && onSaveAsTemplate && (
            <button type="button" className={MENU_ITEM} onClick={run(onSaveAsTemplate)}>
              <FontAwesomeIcon icon="bookmark" />
              {I18n.t("quotes.project_templates.save_as_template.button")}
            </button>
          )}
          {quote.export_dpgf_url && (
            <a href={quote.export_dpgf_url} className={MENU_ITEM} onClick={close}>
              <FontAwesomeIcon icon="file-excel" />
              {I18n.t("quotes.import.export")}
            </a>
          )}
          {quote.import_file_url && (
            <a href={quote.import_file_url} className={MENU_ITEM} onClick={close}>
              <FontAwesomeIcon icon="file-arrow-down" />
              {I18n.t("quotes.import.download_file")}
            </a>
          )}
          {(quote.project_url || quote.can_convert_to_project || quote.can_duplicate || quote.can_save_as_template || quote.export_dpgf_url || quote.import_file_url) && quote.can_destroy && (
            <div className={MENU_SEPARATOR} />
          )}
          {quote.can_destroy && onDelete && (
            <button type="button" className={MENU_ITEM_DANGER} onClick={run(onDelete)}>
              <FontAwesomeIcon icon="trash" />
              {I18n.t("button.delete")}
            </button>
          )}
        </MenuPanel>
      )}
    </>
  )
}

export default QuoteRowMenu
